import * as React from 'react'

import { TaskStatusWrapper } from '@/modules/shared/components'
import ViewMode from './ViewMode'
import YearPickerButton from '../datepickers/YearPickerButton'
import MonthPickerButton from '../datepickers/MonthPickerButton'
import { useDriversGroupTimesheetStore } from '@/modules/drivers/stores/driversGroupTimesheetStore'
import { useShallow } from 'zustand/shallow'
import { RouteComponentProps, withRouter } from '@/app/navigation/withRouter'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = RouteComponentProps<{ companyId: string }> & {
  displayYearPicker?: boolean
  displayMonthPicker?: boolean
}

const TopBarGroupContainerContent = ({
  displayMonthPicker,
  displayYearPicker,
}: Props) => {
  const {t} = useLocalize()
  const { viewedYear, setViewedYear } = useDriversGroupTimesheetStore(
    useShallow((s) => ({
      viewedYear: s.viewedYear,
      setViewedYear: s.setViewedYear,
    })),
  )

  return (
    <TaskStatusWrapper>
      <div className="tw-relative tw-flex tw-w-full tw-flex-row tw-justify-between tw-gap-2 tw-border-b md:tw-gap-4">
        <ViewMode />
   
        <div className="tw-z-[200] tw-flex tw-flex-wrap-reverse tw-justify-between tw-gap-2 tw-px-4 tw-py-2 sm:tw-items-center sm:tw-justify-start sm:tw-gap-6">
          {displayYearPicker && (
            <YearPickerButton
              value={viewedYear}
              handleChangeValue={setViewedYear}
            />
          )}

          {displayMonthPicker && <MonthPickerButton />}
        </div>
      </div>
    </TaskStatusWrapper>
  )
}

export const TopBarGroupContainer = withRouter(TopBarGroupContainerContent)
